import { useParams } from "react-router-dom";
import { projectsData, defaultData } from "./StaticData/HomeProjectData";
import HomeFooter from "../Component/HomeComponent/HomeFooter";

import { useState, useEffect } from "react";
import { Space, Col, Row, Image } from "antd";
import { useLocation } from "react-router-dom";
import HomeHeader from "../Component/HomeComponent/HomeHeader";

import ReactPlayer from "react-player";
import {
  TitleContainer,
  PageContainer,
  FirstSectionContainer,
  DetailsContainer,
  SubPageTitle,
  SectionContainer,
} from "../Component/HomeComponent/GeneralComponents";
import TransparentCard from "../Component/HomeComponent/TransparentCard";
import SubPageDetails from "../Component/HomeComponent/SubPageDetails";
import ArrowCarousel from "../Component/HomeComponent/ArrowCarousel";

export default function HomeProject() {
  let { page } = useParams();
  const [ismobile, setIsMobile] = useState(0);
  const [key, setKey] = useState(0);
  const location = useLocation();
  const [videoUrl, setVideoUrl] = useState("");

  const [imgDisplay, setImgDisplay] = useState(true);
  const [data, setData] = useState(defaultData);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
    setKey((prevKey) => prevKey + 1);
  }, [location]);
  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerHeight > window.innerWidth ? 1 : 0);
    window.addEventListener("resize", handleResize);
    // Call handleResize right away so that ismobile is set correctly initially
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const foundProject = projectsData.find(
      (project) => project.link.split("/").pop() === page
    );
    if (foundProject) {
      setData(foundProject);
    } else {
      setData(projectsData[projectsData.length - 1]);
    }
  }, [page]);

  useEffect(() => {
    const fetchVideoUrl = async () => {
      setVideoUrl(data.showcase);
    };

    if (data.showcase.includes("youtu.be")) {
      setImgDisplay(false);
      fetchVideoUrl();
    } else {
      setImgDisplay(true);
    }
  }, [data]);

  return (
    <PageContainer key={key}>
      <div>
        <FirstSectionContainer ismobile={ismobile} bg={data.image}>
          <HomeHeader style={{ position: "relative", zindex: "2" }} />
          <TitleContainer ismobile={ismobile} style={{ marginTop: "-3vh" }}>
            {data.title}
          </TitleContainer>
          <DetailsContainer ismobile={ismobile} style={{ marginTop: "-5vh" }}>
            <Space
              direction="vertical"
              size="small"
              style={{
                width: ismobile ? "70vw" : "40vw",
                fontSize: "inherit",
              }}
            >
              <Row style={{ paddingBottom: "3vh", fontSize: "inherit" }}>
                <Col
                  span={24}
                  style={{
                    fontWeight: 900,
                    fontSize: "inherit",
                  }}
                >
                  Client:{" "}
                </Col>
                <Col span={24} style={{ fontSize: "inherit" }}>
                  {data.client}
                </Col>
              </Row>
              <Row style={{ paddingBottom: "3vh", fontSize: "inherit" }}>
                <Col
                  span={24}
                  style={{
                    fontWeight: 900,
                    fontSize: "inherit",
                  }}
                >
                  Location:{" "}
                </Col>
                <Col span={24} style={{ fontSize: "inherit" }}>
                  {data.location}
                </Col>
              </Row>
              {data.services && data.services.trim() !== "" ? (
                <>
                  <div
                    style={{
                      fontWeight: 900,
                    }}
                  >
                    Services:{" "}
                  </div>
                  {data.services.split("&").map((service, index) => {
                    return (
                      <div
                        style={{
                          paddingLeft: "1vw",
                          paddingTop: ismobile ? "0" : "-0.5vh",
                        }}
                        key={index + service}
                      >
                        &bull; {service}
                      </div>
                    );
                  })}
                </>
              ) : (
                <div></div>
              )}
            </Space>
          </DetailsContainer>
        </FirstSectionContainer>
        {imgDisplay ? (
          <div
            style={{
              width: "auto",
              height: "auto", // Use the image height here
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "5vh 10vw",
            }}
          >
            <Image
              alt="showcase"
              src={data.showcase}
              style={{
                borderRadius: 10,
                height: "auto",
                objectFit: "contain",
                width: "100%",
                maxHeight: "70vh",
              }}
            />
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              height: "auto",
              paddingTop: " 5vh",
              paddingBottom: "5vh",
            }}
          >
            <div
              style={{
                height: "auto",
                width: ismobile ? "80%" : "70%",
                position: "relative",
              }}
            >
              <ReactPlayer
                url={videoUrl}
                playsinline
                muted
                controls
                playing
                height="auto"
                width="100%"
                style={{
                  aspectRatio: "16/9",
                  maxWidth: "100%",
                }}
                loop
              />
            </div>
          </div>
        )}

        <SubPageDetails ismobile={ismobile}>{data.introduction}</SubPageDetails>

        <SectionContainer>
          <SubPageTitle ismobile={ismobile} style={{ paddingTop: "15vh" }}>
            Outcomes
          </SubPageTitle>

          <ArrowCarousel
            style={{
              display: "flex",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
            more={false}
            isMobile={ismobile}
          >
            {data.outcome.image.map((image, index) => {
              return (
                <div
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: 10,
                  }}
                  key={index + image}
                >
                  <Image
                    src={image}
                    alt="showcase"
                    style={{ width: "100%", borderRadius: 10 }}
                  />
                </div>
              );
            })}
          </ArrowCarousel>
        </SectionContainer>

        <SectionContainer>
          <SubPageTitle ismobile={ismobile} style={{ paddingTop: "15vh" }}>
            More of Our Work
          </SubPageTitle>

          <ArrowCarousel
            isMobile={ismobile}
            more={true}
            style={{
              display: "flex",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {projectsData.map((project, index) => {
              if (project.link.split("/").pop() !== page) {
                return (
                  <div>
                    <TransparentCard
                      option={project}
                      key={index + project.title}
                    />
                  </div>
                );
              } else {
                return null;
              }
            })}
          </ArrowCarousel>
        </SectionContainer>
        <HomeFooter />
      </div>
    </PageContainer>
  );
}
